import { Link } from "react-router-dom";
import { Aperture, Facebook, Instagram, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { scrollTo } from "./Nav";
import { ZONES } from "../lib/zones";
import { FACEBOOK_URL, INSTAGRAM_URL } from "../lib/social";

const goFooter = (href) => {
  if (document.querySelector(href)) scrollTo(href);
  else window.location.assign(`/${href}`);
};

export const Footer = () => {
  const { t } = useTranslation();
  const links = t("footer.links", { returnObjects: true });

  return (
  <footer className="border-t border-white/5 bg-[#0D0F12] px-6 py-16 lg:px-12" data-testid="footer">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
        <div>
          <div className="flex items-center gap-2.5">
            <Aperture className="h-5 w-5 text-[#D6705A]" strokeWidth={1.5} />
            <span className="font-display text-lg tracking-wide text-[#F9F8F6]">
              L&rsquo;Obiettivo <span className="italic text-[#D6705A]">Immobiliare</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#666]">
            {t("footer.tagline")}
          </p>
        </div>

        <div className="flex flex-wrap gap-16">
          <div>
            <p className="font-code text-[10px] uppercase tracking-[0.3em] text-[#666]">{t("footer.navLabel")}</p>
            <div className="mt-4 space-y-3">
              {links.map(([label, href]) => (
                <button key={href} onClick={() => goFooter(href)} className="block text-sm text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]" data-testid={`footer-link-${href.replace("#", "")}`}>
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <p className="font-code text-[10px] uppercase tracking-[0.3em] text-[#666]">{t("footer.zonesLabel")}</p>
            <div className="mt-4 space-y-3">
              {ZONES.map((z) => (
                <Link key={z.slug} to={`/${z.slug}`} className="block text-sm text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]" data-testid={`footer-zone-${z.slug}`}>
                  {z.name}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <p className="font-code text-[10px] uppercase tracking-[0.3em] text-[#666]">{t("footer.contactsLabel")}</p>
            <div className="mt-4 space-y-3">
              <a href="mailto:info@lobiettivoimmobiliare.it" className="flex items-center gap-2 text-sm text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]" data-testid="footer-email-link">
                <Mail className="h-3.5 w-3.5" /> info@lobiettivoimmobiliare.it
              </a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]" data-testid="footer-instagram-link">
                <Instagram className="h-3.5 w-3.5" /> Instagram
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-[#A0A0A0] transition-colors duration-300 hover:text-[#F9F8F6]" data-testid="footer-facebook-link">
                <Facebook className="h-3.5 w-3.5" /> Facebook
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-3 border-t border-white/5 pt-8 md:flex-row md:items-center md:justify-between">
        <p className="font-code text-[10px] uppercase tracking-[0.25em] text-[#555]">
          © {new Date().getFullYear()} L&rsquo;Obiettivo Immobiliare — Trapani · Palermo · Sicilia
        </p>
        <div className="flex items-center gap-6">
          <button
            type="button"
            onClick={() => window.dispatchEvent(new CustomEvent("loi:open-cookie-preferences"))}
            className="font-code text-[10px] uppercase tracking-[0.25em] text-[#555] transition-colors duration-300 hover:text-[#A0A0A0]"
            data-testid="cookie-preferences-link"
          >
            {t("consent.footerLink")}
          </button>
          <a href="/admin/login" className="font-code text-[10px] uppercase tracking-[0.25em] text-[#555] transition-colors duration-300 hover:text-[#A0A0A0]" data-testid="footer-admin-link">
            Area riservata
          </a>
        </div>
      </div>
    </div>
  </footer>
  );
};
